export default __webpack_public_path__ + "static/media/regional-icon.ff789d0a.svg";